export type StatusPillOverrides = Readonly<Record<string, string>>;

export const SERVICE_REQUEST_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    NEW: 'green-pill',
    CRT: 'yellow-pill',
    SNT: 'orange-pill',
    WAT: 'dark-blue-pill',
    APT: 'purple-pill',
    UPD: 'brown-pill',
    COM: 'black-pill',
    CAN: 'white-pill',
    DEC: 'red-pill',
    DLT: 'white-pill',
    INP: 'green-pill'
});

export const WORKFLOW_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    WFA: SERVICE_REQUEST_STATUS_PILL_OVERRIDES.WAT,
    '2ND_WFA': SERVICE_REQUEST_STATUS_PILL_OVERRIDES.WAT,
    '3RD_WFA': SERVICE_REQUEST_STATUS_PILL_OVERRIDES.WAT,
    APP: SERVICE_REQUEST_STATUS_PILL_OVERRIDES.APT,
    PFA: SERVICE_REQUEST_STATUS_PILL_OVERRIDES.UPD,
    REJ: SERVICE_REQUEST_STATUS_PILL_OVERRIDES.DEC
});

export const PCS_DOCUMENT_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    NFA: 'light-grey-pill',
    DEL: 'dark-red-pill',
    ONH: 'purple-pill'
});

export const VISIT_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    ETE: 'green-pill',
    ETL: 'orange-pill',
    RTE: 'yellow-pill',
    LTP: 'black-pill',
    RTL: 'brown-pill'
});

export const SHIPMENT_POOL_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    NEW: 'yellow-pill',
    ACT: 'green-pill'
});

export const RELEASE_ORDER_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    RLS: 'green-pill'
});

export const STORAGE_DOCUMENT_ITEM_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    ANN: 'yellow-pill'
});

export const GENERAL_ACT_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    LOC: 'green-pill'
});

export const VESSEL_VISIT_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    EXA: 'green-pill',
    ARR: 'dark-green-pill',
    EXD: 'orange-pill',
    DEP: 'blue-pill'
});

const COMMON_STATUS_PILL_OVERRIDES: StatusPillOverrides = Object.freeze({
    ...SERVICE_REQUEST_STATUS_PILL_OVERRIDES,
    ...WORKFLOW_STATUS_PILL_OVERRIDES
});

function normalizeStatusId(statusId: string | null | undefined): string {
    return typeof statusId === 'string' ? statusId.toUpperCase() : '';
}

export function getStatusPillClass(statusId: string | null | undefined, overrides?: StatusPillOverrides): string {
    const normalizedStatusId = normalizeStatusId(statusId);

    if (!normalizedStatusId) {
        return '';
    }

    return overrides?.[normalizedStatusId] ?? COMMON_STATUS_PILL_OVERRIDES[normalizedStatusId] ?? '';
}
